/* eslint-disable security/detect-object-injection */

const accountMapperCANZ = (form) => {
    // Main regex
    // let ddInfo = {
    //         bankAccounts: []
    //     },
    let bankData = {
        'accountName': form.name,
        'accountNumber': form.accountNumber,
        'bankName': form.bankName,
        'branchNumber': form.branchNumber,
        'routingNumber': form.bankNumber,
        'accountPurpose': 'DIRECT_DEPOSIT',
        'accountType': 'C',
        'acceptedDirectDepositPolicy': true,
        'country': form.country,
        'action': 'ADD'
    };
    //ddInfo.push(bankData);
    // Return compiled regex 
    // return ddInfo;
    return bankData;
};


const ddMapper = (form, country) => {
    // Main regex
    // let ddInfo = {
    //         bankA
    let bankData;
    switch (country){
        case 'NZ':
        case 'CA':
            bankData = {
                'nameOnAccount': form.name,
                'accountNumber': form.accountNumber,
                'bankName': form.bankName,
                'branchNumber': form.branchNumber,
                'routingNumber': form.bankNumber,
                'accountPurpose': 'DIRECT_DEPOSIT',
                'accountType': 'C',
                'acceptedDirectDepositPolicy': true,
                'country': country,
                'action': 'ADD'
            };
            break;
        case 'US':
            bankData = {
                'nameOnAccount': form.accountName,
                'accountNumber': form.accountNumber,
                'routingNumber': form.routingNumber,
                'accountPurpose': 'DIRECT_DEPOSIT',
                'accountType': form.accountType,
                'acceptedDirectDepositPolicy': true,
                'country': country,
                'action': 'ADD'
            };
            break;
        case 'AU':
            bankData = {
                'nameOnAccount': form.name,
                'accountNumber': form.accountNumber,
                'branchNumber': form.branchNumber,
                'routingNumber': form.bankNumber,
                'accountPurpose': 'DIRECT_DEPOSIT',
                'accountType': 'C',
                'acceptedDirectDepositPolicy': true,
                'country': country,
                'action': 'ADD'
            };
            break;
        case 'GB':
        case 'ZA':
        case 'IE':
            bankData = {
                'accountHolder': form.name,
                'bankName': form.bankName,
                'accountNumber': form.accountNumber,
                'routingNumber': form.routingNumber
            };
            break;
        default:
            bankData = {
                'accountHolder': form.name,
                'bankName': form.bankName,
                'IBAN': form.accountNumber
            };
    }

    return bankData;
};
 
export default {
    accountMapperCANZ:accountMapperCANZ,
    ddMapper:ddMapper
};